import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Alert, AlertDescription } from '../ui/alert';
import { Loader2, Mail } from 'lucide-react';
import { userService } from "../../_services";

function AppleModal({ isOpen, onClose, applePass, homepagePass, showApplePopup, browserName }) {
    const [emailField, setEmailField] = useState('');
    const [loader, setLoader] = useState(false);
    const [errorEmail, setErrorEmail] = useState('');
    const [errors, setErrors] = useState('');

    const sendEmail = async () => {
        try {
            setLoader(true);
            setErrorEmail('');
            setErrors('');

            let Apple_passlink;
            if (homepagePass === true) {
                Apple_passlink = 'https://passes.nulifespanrx.com/passes/apple/apple_gn_20250616051852.pkpass';
            } else {
                Apple_passlink = applePass;
            }

            const Email = emailField.trim();
            
            if (Email === '') {
                setErrorEmail('Email required');
                setLoader(false);
                return;
            }
            
            if (userService.ValidEmailRegex(Email) === false) {
                setEmailField('');
                setErrorEmail('Invalid email');
                setLoader(false);
                return;
            }

            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const apidata = await userService.IphoneChromeEmail(Apple_passlink, Email);
            
            if (apidata[0].code == "1") {
                setErrors('Your card is successfully shared');
                setLoader(false);
                setTimeout(() => {
                    onClose();
                }, 2000);
            } else {
                setErrors(apidata[0].message);
                setLoader(false);
            }
        } catch (error) {
            console.error('Error sending email:', error);
            setErrors('Failed to send email. Please try again.');
            setLoader(false);
        }
    };

    const handleChange = (e) => {
        setEmailField(e.target.value);
        setErrorEmail('');
        setErrors('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendEmail();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Share Pass</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    {showApplePopup && browserName && (
                        <Alert>
                            <Mail className="h-4 w-4" />
                            <AlertDescription>
                                You're using {browserName}. Please use Safari to add the pass directly, 
                                or enter your email below to receive the pass link.
                            </AlertDescription>
                        </Alert>
                    )}

                    <p className="text-sm text-gray-600">
                        Please share your email below to receive pass link on email
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="email">Email Address</Label>
                            <Input
                                id="email"
                                type="email"
                                name="emailField"
                                placeholder="Enter your email address"
                                value={emailField}
                                onChange={handleChange}
                                disabled={loader}
                                autoComplete="off"
                            />
                            {errorEmail && (
                                <p className="text-sm text-red-600">{errorEmail}</p>
                            )}
                        </div>

                        <Button
                            type="submit"
                            onClick={sendEmail}
                            disabled={loader}
                            className="w-full"
                            variant="secondary"
                        >
                            {loader ? (
                                <><Loader2 className="h-4 w-4 animate-spin mr-2" />Sending...</>
                            ) : (
                                'Send'
                            )}
                        </Button>
                    </form>

                    {errors && (
                        <Alert variant={errors.includes('successfully') ? 'default' : 'destructive'}>
                            <AlertDescription>{errors}</AlertDescription>
                        </Alert>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default AppleModal;
